export default defineNuxtPlugin((nuxtApp) => {
  const env = import.meta.env.VERCEL_ENV || import.meta.env.NODE_ENV;
  // Enables Vue Devtools for staging/preview environments or non-production builds
  if (import.meta.env.NUXT_ENABLE_DEVTOOLS === 'true') {
    nuxtApp.vueApp.config.devtools = true;
  }
});
